var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "claim") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0403\\u66F4\\u65B0--my-balance\\u5F39\\u7A97-assets",
    transform: "translate(-805.000000, -405.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(500.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-36",
    transform: "translate(280.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "claim",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.250000, 2.500000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 11.25,
    width: 5,
    height: 13.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375,0 C15.58,0 12.5,3.08 12.5,6.875 C12.5,10.67 15.58,13.75 19.375,13.75 C23.17,13.75 26.25,10.67 26.25,6.875 C26.25,3.08 23.17,0 19.375,0 Z M20.344375,11.061875 L20.344375,12.375 L18.50875,12.375 L18.50875,11.048125 C17.333125,10.800625 16.33625,10.044375 16.260625,8.710625 L17.608125,8.710625 C17.676875,9.4325 18.171875,9.99625 19.43,9.99625 C20.7775,9.99625 21.08,9.3225 21.08,8.903125 C21.08,8.3325 20.7775,7.79625 19.244375,7.431875 C17.539375,7.019375 16.370625,6.318125 16.370625,4.90875 C16.370625,3.72625 17.32625,2.95625 18.50875,2.701875 L18.50875,1.375 L20.344375,1.375 L20.344375,2.715625 C21.623125,3.025 22.2625,3.994375 22.30375,5.04625 L20.95625,5.04625 C20.921875,4.283125 20.51625,3.760625 19.43,3.760625 C18.39875,3.760625 17.78,4.228125 17.78,4.888125 C17.78,5.465625 18.226875,5.84375 19.615625,6.20125 C21.004375,6.55875 22.489375,7.156875 22.489375,8.889375 C22.4825,10.1475 21.540625,10.835 20.344375,11.061875 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75,18.75 L15,18.75 L12.3875,17.8375 L12.8,16.6625 L15,17.5 L18.525,17.5 C19.3375,17.5 20,16.8375 20,16.025 L20,16.025 C20,15.4125 19.6125,14.8625 19.0375,14.6375 L9.9625,11.25 L7.5,11.25 L7.5,22.525 L16.25,25 L26.2625,21.25 L26.2625,21.25 C26.25,19.875 25.1375,18.75 23.75,18.75 Z",
    id: "\\u8DEF\\u5F84"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/claim.29b6045f7778c1374bb62ff5c625b1c1.svg";
export { ForwardRef as ReactComponent };